import React, { useEffect } from "react";
import styles from "./RegisterSidePanel.scss";
import cx from "../utils/cx";
import { createModal } from "../utils/CreateModal";
import useUser from "../stores/useUser";
import InstantMessageIcon from '../assets/img/teaser/instant-messages.svg';
import FinanzBestIcon from '../assets/img/teaser/finanzierungsbestaetigung.svg';
import SchufaBonIcon from '../assets/img/teaser/schufa-bonitaetscheck.svg';
import PropertyRequest from "../utils/PropertyRequest";
import { loadGoogleMapsScript } from "../utils/loadScript";
import { IProperty } from "../utils/JsonApiRequest";
import Button from "./MaterialUi/Button";

export const pathFinanzierungsbestaetigung = '/service/finanzierungsbestaetigung';

export interface IRegisterSidePanelProps {
  className?: string;
  uuid: IProperty['id'];
}

const loadPlaceAndOpenModal = (uuid: IProperty['id']): Promise<any> => {
    return PropertyRequest.getProperty(uuid).then((property) => {
        const searchState = { mode: 'locality' as const, locality: property.locality || property.field_address.locality };
        createModal.createSaveSearchForm(undefined, searchState);
    })
};

const RegisterSidePanel: React.FC<React.PropsWithChildren<IRegisterSidePanelProps>> = ({ className = '', uuid }) => {

    const [user] = useUser();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [property, setProperty] = React.useState<IProperty>({} as IProperty);

    useEffect(() => {
        if (user.isLoggedIn) {
            loadGoogleMapsScript()
        }
    }, [user.isLoggedIn]);

    useEffect(() => {
        PropertyRequest.getProperty(uuid)
            .then((propertyData) => {
                setProperty(propertyData);
            });
    }, [user, uuid]);

    if (!user.isInitialized) {
        return null;
    }

    const handleClick = () => {
        const trackingEvent = {
            'event': 'login_register',
            'event_name': 'login_register',
            'streckenzweig1': 'Registrieren',
            'streckenzweig2': "Suchauftrag anlegen",
            'counter': 1,
        };
        createModal.createRegisterPromise(trackingEvent).then(() => {
        }).catch(console.error);
    };

    const handleSaveSearchButtonClick = () => {
        setIsLoading(true);
        loadPlaceAndOpenModal(uuid).then(data => {
            setIsLoading(false)
        })
            .catch((e) => {
                setIsLoading(false);
            });
    };


    return <div>
        {property.type_of_marketing === 'rent' ? ( 
            <div className={cx(styles.registerSidePanel, className)} >
                <h5>Mit dem SCHUFA-BonitätsCheck ins neue Zuhause</h5>
                <div className={styles.teaser}>
                    <p>Überzeuge deinen künftigen Vermieter von dir und mach jetzt den SCHUFA-BonitätsCheck! Erhalte dein persönliches Zertifikat in nur 3 Minuten.</p>
                </div>
                <div className={styles.serviceIcon}>
                    <SchufaBonIcon />
                </div>
                <Button href="/service/schufabonitaetscheck" loading={isLoading}>SCHUFA-BonitätsCheck erhalten</Button>
            </div >
        ):(
            <div className={cx(styles.registerSidePanel, className)} >
                <h5>Erhöhe deine Chancen beim Hauskauf!</h5>
                <div className={styles.teaser}>
                    <p>Punkte jetzt beim Kaufen mit einer Finanzierungsbestätigung. Erhalte in 3 Minuten deine Bestätigung - kostenlos und unverbindlich!</p>
                </div>
                <div className={styles.serviceIcon}>
                    <FinanzBestIcon />
                </div>
                <Button href="/service/finanzierungsbestaetigung" loading={isLoading}>Finanzierungsbestätigung erhalten</Button>
            </div >
        )}
        {user.isLoggedIn ? (
            <div className={cx(styles.registerSidePanel, className)} >
                <h5>Schneller zur passenden Immobilie:</h5>
                <Button onClick={handleSaveSearchButtonClick} loading={isLoading}>Suchauftrag anlegen</Button>
                <p>kostenlos & unverbindlich</p>
            </div >
        ):(
            <div className={cx(styles.registerSidePanel, className)}>
                <h5>Schneller zur passenden Immobilie:</h5>
                <h6>Kostenlosen Suchauftrag anlegen!</h6>
                <div className={styles.teaser}>
                    <InstantMessageIcon />
                    <p>Wir informieren Dich bequem per E-Mail über neue Ergebnisse passend zu Deiner Immobiliensuche.</p>
                </div>
                <Button onClick={handleClick}>Jetzt registrieren und Suchauftrag anlegen</Button>
                <p>kostenlos & unverbindlich</p>
            </div>
        )}
    </div>
};

export default RegisterSidePanel;
